//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export default angular.module('curalate.promoted-posts-metrics', [
  'curalate',
]);
